<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-22 16:13:21
 * @LastEditors: chen wei
 * @LastEditTime: 2020-05-25 08:53:15
-->
<template>
<div class="playerAll">
  <aplayer class="musicPlayer" @play="playFun" ref="aplayerAll" theme="#45d585" loop="none" :audio="currentMusicAll" />
</div>
</template>

<script>
export default {
  name: 'ZhlAplayer',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentMusicAll: {
        name: '',
        artist: '',
        url: ''
      }
    }
  },
  watch: {
    url(val) {
      this.currentMusicAll.url = val
    }
  },
  mounted() {
    this.currentMusicAll.url = this.url
  },
  methods: {
    playFun() {
      window.cmiheePlayer = this.$refs.aplayerAll
    },
    stop() {
      this.$refs.aplayerAll.pause()
    }
  }
}
</script>

<style lang="less" scoped>
.playerAll {
  /deep/ .musicPlayer {
    margin: 0;
    height: 50px;
    background: rgba(245, 247, 250, 1);
    border-radius: 8px;

    .aplayer-body {
      .aplayer-pic {
        height: 50px;
        width: 50px;
        background: none !important;

        .aplayer-play {
          background: rgb(69, 213, 133);
          border: 2px solid rgb(69, 213, 133);
        }

        .aplayer-pause {
          width: 26px;
          height: 26px;
          background: rgb(69, 213, 133);
          border: 2px solid rgb(69, 213, 133);
          bottom: 50%;
          right: 50%;
          margin: 0 -15px -15px 0;

          svg {
            top: 3px;
            left: 3px;
            height: 20px;
            width: 20px;
          }
        }
      }
    }

    .aplayer-info {
      height: 50px;
      margin-left: 50px;
      display: flex;
      align-items: center;
      padding: 0;

      .aplayer-music {
        display: none;
      }
    }

    .aplayer-controller {
      flex: 1;
      // overflow: hidden;
      align-items: center;
      padding-right: 6px;

      // padding-left: 6px;
      .aplayer-bar-wrap {
        padding: 0;
        margin: 0;
      }

      .aplayer-time {
        position: static;
        font-size: 12px;
        font-weight: 400;
        color: rgba(164, 167, 176, 1);
      }

      .aplayer-icon {
        display: none;
      }
    }

    .aplayer-notice {
      display: none !important;
    }
  }
}
</style>
